import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {
  NavBar,
  CellGroup,
  Cell,
  Field,
  Button,
  Empty,
  Popup,
  Picker,
  DatetimePicker,
  Area,
  Cascader,
  Uploader,
  Dialog,
  Toast,
  Search,
  List,
} from 'vant'

// 全局注册常用 Vant 组件，供各步骤页直接使用
Vue.use(NavBar)
Vue.use(CellGroup)
Vue.use(Cell)
Vue.use(Field)
Vue.use(Button)
Vue.use(Empty)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(DatetimePicker)
Vue.use(Area)
Vue.use(Cascader)
Vue.use(Uploader)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Search)
Vue.use(List)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
